import React from "react";
import { motion } from "framer-motion";
import { getIcon } from "@/lib/icons";

export const DeckSelector = ({ decks, selectedId, onSelect }) => {
  return (
    <div className="grid gap-5 sm:grid-cols-2" data-testid="deck-selector">
      {decks.map((deck) => {
        const active = deck.id === selectedId;
        const Icon = getIcon(deck.type === "tarot" ? "Star" : "Moon");
        return (
          <motion.button
            key={deck.id}
            type="button"
            onClick={() => onSelect(deck.id)}
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.985 }}
            data-testid={`deck-option-${deck.id}`}
            className={`group relative overflow-hidden rounded-2xl border p-6 text-left transition-all ${
              active
                ? "border-[#D9A441]/70 bg-[#131422] shadow-[0_0_30px_rgba(217,164,65,0.15)]"
                : "border-[#D9A441]/15 bg-[#131422]/60 hover:border-[#D9A441]/40"
            }`}
          >
            <div
              className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full opacity-20 blur-2xl transition-opacity group-hover:opacity-40"
              style={{ background: deck.type === "tarot" ? "#D9A441" : "#722F37" }}
            />
            <div className="mb-4 flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#D9A441]/40 bg-[#0B0C15]/60">
                <Icon className="h-5 w-5 text-[#D9A441]" strokeWidth={1.5} />
              </span>
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#A3A5B8]">
                {deck.type}
              </span>
            </div>
            <h3 className="font-display text-2xl font-semibold leading-tight text-[#F8F3E6]">
              {deck.name}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-[#A3A5B8]">{deck.tagline}</p>
            <div className="mt-4 flex items-center gap-3 text-xs text-[#A3A5B8]">
              <span>{deck.card_count} cards</span>
              <span className="h-1 w-1 rounded-full bg-[#D9A441]/50" />
              <span>{deck.supports_reversals ? "reversals" : "no reversals"}</span>
            </div>
            {active && (
              <span className="absolute bottom-4 right-5 text-xs font-medium tracking-wide text-[#E5C365]">
                Selected ✦
              </span>
            )}
          </motion.button>
        );
      })}
    </div>
  );
};
